import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import commonMessages from 'sg-common-messages';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalBody,
    ModalFooter,
    IconButton
} from '@jutro/components';
import htmlParser from 'html-react-parser';
import styles from 'saga-styling/common-styles/widgets/ModalHeader.module.scss';

function SgSectionsModalCtrl(props) {
    const {
        title,
        closeBtnLabel,
        isOpen,
        onResolve,
        className,
        commonSection,
        titleVisibility,
        sections,
        messages,
        messageParams
    } = props;

    const translator = useContext(TranslatorContext);

    const btnLabel = _.isEmpty(closeBtnLabel) ? commonMessages.ModalMessageClose : closeBtnLabel;
    const visible = _.isEmpty(titleVisibility) ? titleVisibility : !titleVisibility;

    const drawListItems = (listItems) => {
        return listItems.map((item) => {
            return (
                <li key={`item_${item}`}>{translator(messages[item], messageParams)}</li>
            );
        });
    };

    const drawList = (items, itemKey, type) => {
        if (type === 'ol') {
            return (
                <ol className={items.listClass}>
                    {drawListItems(items[itemKey])}
                </ol>
            );
        }
        return (
            <ul className={items.listClass}>
                {drawListItems(items[itemKey])}
            </ul>
        );
    };

    const drawMessages = (messagesList) => {
        return messagesList.map((message) => {
            return (
                <div key={`message_${message.id}`} className="gw-message sg-modal-message">
                    { message.type === 'normal'
                        && (
                            <p>{translator(messages[message.message], messageParams)}</p>
                        )
                    }

                    { message.type === 'list'
                        && (
                            <div>
                                <p>{translator(messages[message.listTitle], messageParams)}</p>
                                {drawList(message, 'points', 'ol')}
                            </div>
                        )
                    }

                    { message.type === 'questionAndAnswer'
                        && (
                            <div>
                                <p className="sg-modal-question">{translator(messages[message.question], messageParams)}</p>
                                { message.answerType === 'normal'
                                    && <p>{translator(messages[message.answer], messageParams)}</p>
                                }
                                { message.answerType === 'list'
                                    && drawList(message, 'answers', 'ul')
                                }
                            </div>
                        )
                    }
                </div>
            );
        });
    };

    const drawSections = () => {
        return sections.map((section) => {
            return (
                <div key={`section_${section.id}`}>
                    <div className="gw-heading sg-modal-header">
                        {translator(messages[section.topic], messageParams)}
                    </div>

                    {drawMessages(section.messages)}
                </div>
            );
        });
    };

    return (
        <ModalNext isOpen={isOpen}>
            <div className={className}>
                <img
                    id="sagaLogo_modal"
                    src="https://asset.saga.co.uk/common/brand2021/logo/Saga_Logo_Indigo.svg"
                    alt="Saga logo"
                    className="saga-logo-cancel-modal"
                />

                <div className="sgModalCloseButtonContainer">
                    <IconButton
                        type="button"
                        id="modalCloseButtonCross"
                        className={styles.closeButton}
                        onClick={onResolve}
                        size="small"
                        icon="mi-close"
                    />
                </div>

                <ModalBody
                    contentLayout={{
                        component: 'div'
                    }}
                >
                    <div id="modalTitle" className="gw-heading sg-modal-header">
                        {visible && title }
                    </div>

                    {commonSection
                        && (
                            <div>{htmlParser(translator(commonSection), messageParams)}</div>
                        )
                    }

                    <div id="modalSections">
                        {drawSections()}
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button onClick={onResolve}>
                        {btnLabel}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

export default SgSectionsModalCtrl;
